'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CMS_CTA_TYPES = exports.CMS_CTA_TYPES = {
  OFFER_CHECKOUT: 'ctaOfferCheckout',
  RAF: 'ctaReferAFriend',
  YOUTUBE_VIDEO: 'ctaYoutubeVideo',
  URL: 'callToAction'
};